import { useEffect } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="container privacy-policy-heading">
        <Header />
        <header className="main-header-section">
          <div className="header-max-width-wrapper">
            <h1>Terms of Service for Ye Apni Gaadi</h1>
            <p>Last Updated: 11 Feb 2026</p>
          </div>
        </header>
        <main className="document-container">
          <article className="policy-paper-card">
            <section className="policy-section">
              <h2>1. Acceptance of Terms</h2>
              <p>
                By downloading, installing, or using the Ye Apni Gaadi
                application ("App"), you agree to be bound by these Terms of
                Service ("Terms"). If you do not agree, do not use the App.
              </p>
            </section>
            <section className="policy-section">
              <h2>2. Account Registration and Access</h2>
              <ul>
                <li>
                  <strong>Restricted Access:</strong> Ye Apni Gaadi operates on
                  a closed-network model. You acknowledge that individual
                  registration is not open to the public.
                  <ul>
                    <li>
                      <strong>Drivers:</strong> Must be onboarded/added by a
                      registered Fleet Operator
                    </li>
                    <li>
                      <strong>Corporate/Fleet Users:</strong> Access is granted
                      upon verification and onboarding by the Platform
                      Administrator or Fleet Operator.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Login:</strong> Access is granted via Phone Number and
                  OTP verification. You are responsible for maintaining the
                  confidentiality of your device and OTP.
                </li>
              </ul>
            </section>
            <section className="policy-section">
              <h2>3. Services Provided</h2>
              <ul>
                <li>
                  <strong>For Fleet Operators: </strong> Tools to manage
                  drivers, vehicles, and track ride metrics.
                </li>
                <li>
                  <strong>For Companies: </strong> Ability to book rides for
                  employees and track ride status.
                </li>
                <li>
                  <strong>For Drivers:</strong> Interface to accept ride
                  requests, view navigation, and communicate with riders.
                </li>
                <li>
                  <strong>Communication: </strong> The App provides chat
                  (proprietary) and calling features (via Agora/Exotel). By
                  using the calling feature, you consent to the use of number
                  masking/proxy services.
                </li>
              </ul>
            </section>
            <section className="policy-section">
              <h2>4. User Conduct & Compliance</h2>
              <ul>
                <li>
                  <strong>Documents: </strong> You warrant that all documents
                  provided (PAN, Aadhaar, DL, RC, Insurance, etc.) are valid,
                  genuine, and up-to-date. Submitting forged documents will
                  result in immediate termination and legal action.
                </li>
                <li>
                  <strong>Safety: </strong> Zero tolerance for harassment,
                  abuse, or unsafe driving. Drivers must adhere to all local
                  traffic laws.
                </li>
                <li>
                  <strong>Prohibited Use:</strong> You may not use the App for
                  transporting illegal goods, committing crimes, or fraudulent
                  activities.
                </li>
              </ul>
            </section>
            <section className="policy-section">
              <h2>5. Data Usage & Privacy </h2>
              <p>
                {" "}
                Your use of the App is also governed by our Privacy Policy. You
                understand that:
              </p>
              <ul>
                <li>
                  Ride details for corporate bookings are shared with the
                  booking Company.
                </li>
                <li>
                  Identity documents are stored in encrypted formats for
                  compliance.
                </li>
              </ul>
            </section>
            <section className="policy-section">
              <h2>6. Third-Party Services</h2>
              <p>
                {" "}
                The App utilizes third-party services including, but not limited
                to, Google Maps, Agora (for data calls), and Exotel (for
                cellular proxy calls). We are not responsible for the downtime
                or failure of these third-party services.
              </p>
            </section>
            <section className="policy-section">
              <h2>7. Limitation of Liability</h2>
              <p>
                {" "}
                Ye Apni Gaadi acts as a technology platform connecting Fleet
                Operators/Drivers with Customers.
              </p>
              <ul>
                <li>
                  <strong>We are not a transport provider. </strong>We do not
                  own the vehicles (unless explicitly stated) and are not
                  responsible for the behavior of drivers or the condition of
                  vehicles.
                </li>
                <li>
                  To the fullest extent permitted by law, Ye Apni Gaadi shall
                  not be liable for indirect, incidental, or consequential
                  damages arising from the use of the service.
                </li>
              </ul>
            </section>
            <section className="policy-section">
              <h2>8. Termination</h2>
              <p>
                {" "}
                We reserve the right to suspend or terminate your access to the
                App immediately, without notice, if:
              </p>
              <ul>
                <li>You violate these Terms.</li>
                <li>Your documents (License/Permit/Insurance) expire.</li>
                <li>A Fleet Operator removes you from their network.</li>
              </ul>
            </section>
            <section className="policy-section">
              <h2>9. Governing Law</h2>
              <p>
                {" "}
                These Terms shall be governed by and construed in accordance
                with the laws of India. Any disputes shall be subject to the
                exclusive jurisdiction of the courts in Delhi.
              </p>
            </section>
            <section className="policy-section">
              <h2>7. Contact Us</h2>
              <div className="contact-box-simple">
                <p>
                  <strong>Email:</strong> support@yeapnigaadi.com
                </p>
                <p>
                  <strong>Address:</strong> H.No. 618, Near Metro Pillar 42B,
                  Mundka, Delhi, 110041
                </p>
              </div>
            </section>
          </article>
        </main>
      </div>
      <Footer />
    </>
  );
}
